import { render, staticRenderFns } from "./IndividualResult.vue?vue&type=template&id=6c7267e6&scoped=true&"
import script from "./IndividualResult.vue?vue&type=script&lang=js&"
export * from "./IndividualResult.vue?vue&type=script&lang=js&"
import style0 from "./IndividualResult.vue?vue&type=style&index=0&id=6c7267e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7267e6",
  null
  
)

export default component.exports